import type { ReactElement } from 'react'
import en from 'lang/en'
import es from 'lang/es'
import type { AnyObject } from 'typings/custom'

export type TranslationMessage = ((props: AnyObject) => ReactElement) | string

export interface StringsDictionary {
  [key: string]: { [subkey: string]: TranslationMessage }
}

export default { en, es }
